import { render } from "./ozzie.vue?vue&type=template&id=f1e9b31a&scoped=true"
import script from "./ozzie.vue?vue&type=script&lang=js"
export * from "./ozzie.vue?vue&type=script&lang=js"

import "./ozzie.vue?vue&type=style&index=0&id=f1e9b31a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1e9b31a"]])

export default __exports__